import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { runVersionSelfHeal } from "@/versionSelfHeal";

// v2.5.914+ FINALITY FIX — run the version self-heal BEFORE React mounts.
// If the backend reports a newer version than this bundle's PLATFORM_VERSION,
// we purge every cache + service worker + hard-reload once per session, so
// no user can ever see a months-stale bundle again.
runVersionSelfHeal();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
